// Antrean Finance › Approval SPV (batch SISA 24 Sep 2026, KEPUTUSAN-TERTUNDA §69 r).
//
// `GET /finance/approval/pending` mengembalikan TIGA daftar terpisah —
// `{ transactions, piutang, utang, total_pending }` (bentuk ini dikunci
// `test_finance_phase2.py`). Layar dulu membaca `r.data.items`, medan yang tidak
// pernah ada, sehingga halaman SELALU berkata "Tidak ada yang menunggu" padahal
// ada pengajuan yang menunggu SPV. Berkas ini satu-satunya penerjemah bentuk itu
// ke satu daftar kartu.
//
// Sengaja TANPA impor apa pun: logika murni, bisa dimuat Node apa adanya.

// [kunci respons, entity kartu, jalur endpoint keputusan di /finance/{jalur}/{id}/approve|reject]
export const SUMBER_ANTREAN = [
  ["transactions", "transaksi", "transactions"],
  ["piutang", "piutang", "piutang"],
  ["utang", "utang", "utang"],
];

const gabungTeks = (...bagian) => bagian.map((x) => (x || "").toString().trim()).filter(Boolean).join(" — ");

function uraian(entity, d) {
  if (entity === "transaksi") return gabungTeks(d.kategori, d.deskripsi || d.description);
  if (entity === "piutang") return gabungTeks(d.pelanggan_nama, d.kategori, d.keterangan);
  return gabungTeks(d.supplier_nama, d.kategori, d.keterangan);
}

/** Satu daftar kartu dari respons endpoint, terbaru dulu (sama dengan urutan
 *  tiap daftar di backend: `created_at` menurun). Dokumen tanpa `id` dibuang —
 *  tombolnya tidak punya alamat. */
export function gabungAntreanApproval(data) {
  const d = data || {};
  const keluar = [];
  for (const [kunci, entity, jalur] of SUMBER_ANTREAN) {
    for (const doc of Array.isArray(d[kunci]) ? d[kunci] : []) {
      if (!doc || !doc.id) continue;
      keluar.push({
        entity, jalur, id: doc.id, code: doc.code || "",
        description: uraian(entity, doc) || "-",
        nominal: doc.nominal, tanggal: doc.tanggal,
        created_by_name: doc.created_by_name || doc.created_by || "-",
        created_at: doc.created_at || "",
      });
    }
  }
  return keluar.sort((a, b) => (a.created_at < b.created_at ? 1 : a.created_at > b.created_at ? -1 : 0));
}
